export enum PerfilCentralSegurancaEnum {
    ADMINISTRADOR_GERAL = "ParanaAcessivel-AdministradorGeral",
    ADMINISTRATIVO = "ParanaAcessivel-Administrativo",
    GERENCIAL = "ParanaAcessivel-Gerencial",
    REGIONAL = "ParanaAcessivel-Regional"
}